import { makeStyles } from '@material-ui/core/styles'

import { ChatAttachment } from '../../core/types/chat.types'

type MessageAttachmentItemProps = {
  attachment: ChatAttachment
  showSize?: boolean
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    background: 'var(--ds-bg-subtle, #f1f2f7)',
    border: '1px solid var(--ds-border-default, #d7dae4)',
    borderRadius: 10,
    transition: 'background-color 160ms ease',
    '&:hover': {
      background: 'var(--ds-bg-subtle-hover, #e7eaf1)',
    },
  },
  icon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    color: 'var(--ds-fg-secondary, #647089)',
  },
  name: {
    flex: 1,
    minWidth: 0,
    fontSize: '0.875rem',
    color: 'var(--ds-fg-primary, #1f2430)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  size: {
    flexShrink: 0,
    fontSize: '0.75rem',
    color: 'var(--ds-fg-tertiary, #8c92a5)',
  },
}))

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB']
  const unitIndex = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${Math.round((bytes / Math.pow(1024, unitIndex)) * 10) / 10} ${units[unitIndex]}`
}

const MessageAttachmentItem = ({ attachment, showSize = false }: MessageAttachmentItemProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <svg className={classes.icon} viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M9 1H4C3.46957 1 2.96086 1.21071 2.58579 1.58579C2.21071 1.96086 2 2.46957 2 3V13C2 13.5304 2.21071 14.0391 2.58579 14.4142C2.96086 14.7893 3.46957 15 4 15H12C12.5304 15 13.0391 14.7893 13.4142 14.4142C13.7893 14.0391 14 13.5304 14 13V6M9 1L14 6M9 1V6H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className={classes.name} title={attachment.userFilename}>
        {attachment.userFilename}
      </span>
      {showSize && attachment.size ? <span className={classes.size}>{formatFileSize(attachment.size)}</span> : null}
    </div>
  )
}

export default MessageAttachmentItem
